import * as actionTypes from '../constants';
import { updateObject } from '../../utils';

const initialState = {
  questionsResponse: null,
  provincesResponse: null,
  rulesResponse: null,
  vehicleRestrictedResponse: null,
};

const setQuest = (state, action) => {
  return updateObject(state, {
    questionsResponse: action.payload,
  });
};
const setProvinces = (state, action) => {
  return updateObject(state, {
    provincesResponse: action.payload,
  });
};
const setRules = (state, action) => {
  return updateObject(state, {
    rulesResponse: action.payload,
  });
};
const setVehicles = (state, action) => {
  return updateObject(state, {
    vehicleRestrictedResponse: action.payload,
  });
};

const catalog = (state = initialState, action = {}) => {
  switch (action.type) {
    case actionTypes.GET_CATALOG_PROVINCES:
      return setProvinces(state, action);
    case actionTypes.GET_CATALOG_QUEST:
      return setQuest(state, action);
    case actionTypes.GET_CATALOG_RULES:
      return setRules(state, action);
    case actionTypes.GET_CATALOG_VEHICLES:
      return setVehicles(state, action);
    default:
      return state;
  }
};

export default catalog;
